module.exports = __webpack_public_path__ + "static/logo-whit-a8653775d652083dfebcea8b73bed1b1.png";